import { render, staticRenderFns } from "./PreviewSettings.vue?vue&type=template&id=82552d2e&lang=pug"
import script from "./PreviewSettings.vue?vue&type=script&lang=js"
export * from "./PreviewSettings.vue?vue&type=script&lang=js"
import style0 from "./PreviewSettings.vue?vue&type=style&index=0&id=82552d2e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports